import { render, staticRenderFns } from "./ConsumptionChart.global.vue?vue&type=template&id=4084a100&lang=pug&"
import script from "./ConsumptionChart.global.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionChart.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports